/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Mortgage_ContactInputs */

const cs_enum_mortgage_contact = /** @type {(inputs: Enum_Mortgage_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hypotéka`)
};

const en_enum_mortgage_contact = /** @type {(inputs: Enum_Mortgage_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mortgage`)
};

/**
* | output |
* | --- |
* | "Mortgage" |
*
* @param {Enum_Mortgage_ContactInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_mortgage_contact = /** @type {((inputs?: Enum_Mortgage_ContactInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Mortgage_ContactInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_mortgage_contact(inputs)
	return cs_enum_mortgage_contact(inputs)
});